/*
	Maybe use with APP.getView().showChildView('pagingRegion',Backbone.Radio.channel('views').request('pagination'))
	
	More likely in a child view though...
		this.showChildView('paging', Backbone.Radio.channel('views').request('pagination',{
            collection: this.collection
        })); 	


	OPTIONS - only has collections in it
		options = {
			collection	
		}

*/
Backbone.Radio.channel('views').reply('pagination',function(options){
	var pagingView = Marionette.View.extend({
			/* we could just reference options.collections everywhere in here, 
				but this lets us be consistent with other views and use this.collection
			*/
             collection: options.collection
            ,template: function(c){
                var htm  = '';
                
                //if there is only 1 page, just don't show anything
                if(c.state.totalPages===1){ return ""; }
                
                    //figure out what pages to show
                    var pageRange = 2; //we want 2 pages on each side of the current page
                    var rangeStart = c.state.currentPage - pageRange;
                    var rangeEnd   = c.state.currentPage + pageRange;
                    var i;
                    
					if(rangeEnd > c.state.totalPages){
						rangeEnd = c.state.totalPages;
						rangeStart = c.state.totalPages - pageRange * 2;
						rangeStart = rangeStart < c.state.firstPage ? c.state.firstPage : rangeStart;
					}
					
					if(rangeStart <= c.state.firstPage){
						rangeStart = c.state.firstPage;
						rangeEnd = Math.min(pageRange * 2 + 1,c.state.totalPages) 
					}
					
					//let's make some html!
					htm += '<nav><ul class="pagination justify-content-center">'
					
					//previous
                    if(c.state.currentPage != c.state.firstPage){
                        htm += '<li class="page-item">'
                        htm += '    <a class="page-link" href="#" aria-label="Previous" data-page="'+(c.state.currentPage-1)+'">'
                        htm += '        <span aria-hidden="true">&laquo;</span>'
                        htm += '        <span class="sr-only">Previous</span>'
                        htm += '    </a>'
                        htm += '</li>'
                    }
					
					if(rangeStart <= 3){
						for(i=c.state.firstPage;i<rangeStart;i++){
							htm += '<li class="page-item'
	                        if(i===c.state.currentPage){ htm += " active" }
	                        htm += '"><a class="page-link" href="#" data-page="'+i+'">'+i+'</a></li>'	
						}
					}else{
						htm += '<li class="page-item"><a class="page-link" href="#" data-page="'+c.state.firstPage+'">'+c.state.firstPage+'</a></li>'
						htm += '<li class="page-item"><a class="page-link">...</a></li>'
					}
					
					for(i=rangeStart; i<=rangeEnd; i++){
						htm += '<li class="page-item'
                        if(i===c.state.currentPage){ htm += " active" }
                        htm += '"><a class="page-link" href="#" data-page="'+i+'">'+i+'</a></li>'	
					}
					
					if(rangeEnd >= c.state.totalPages - 2){
						for(i=rangeEnd+1; i<= c.state.totalPages; i++){
							htm += '<li class="page-item"><a class="page-link" href="#" data-page="'+i+'">'+i+'</a></li>'
						}
					}else{
						htm += '<li class="page-item"><a class="page-link">...</a></li>'
						htm += '<li class="page-item"><a class="page-link" href="#" data-page="'+c.state.totalPages+'">'+c.state.totalPages+'</a></li>'
					}
					
					
                    //next
                    if(c.state.currentPage != c.state.totalPages){
                        htm += '<li class="page-item">'
                        htm += '    <a class="page-link" href="#" aria-label="Next" data-page="'+(c.state.currentPage+1)+'">'
                        htm += '        <span aria-hidden="true">&raquo;</span>'
                        htm += '        <span class="sr-only">Next</span>'
                        htm += '    </a>'
                        htm += '</li>'
                    }

                    htm += '<li style="padding:0.4rem .75rem;line-height:1.25">Go: <input style="width:30px" /></li>'

                    htm += '</ul></nav>'
                return _.template(htm)
            }
            ,templateContext: function() {
                return {
                    state: this.collection.state
                }
            }
            ,collectionEvents: {
                'update': 'render'
            }
            ,events:{
                "click .page-link": function(e){
                    e.preventDefault();
                    //will automagically update the other views this collection is in
                    this.collection.getPage(+e.currentTarget.dataset.page)
                    
                    var params = (+e.currentTarget.dataset.page!==1)?("page:"+e.currentTarget.dataset.page):"";
					Backbone.history.navigate('/'+this.collection.state.type+ ((params)?"/list/f/"+params:""));
					if(typeof ga != "undefined"){ ga('set','page',  '/'+this.collection.state.type+ ((params)?"/list/f/"+params:"")); }
					if(typeof gtag != "undefined"){ gtag('set', { 'page_path': '/'+this.collection.state.type+ ((params)?"/list/f/"+params:""), 'page_location': window.location.origin+'/'+this.collection.state.type+ ((params)?"/list/f/"+params:"") }); }
                }
                ,"keyup input":function(e){
                    var keycode = e.keyCode || e.which;
                    e.currentTarget.value = e.currentTarget.value.replace(/[^\d]/,'');
                    
                    if(keycode===13 
                        && e.currentTarget.value  !== ""
                        && +e.currentTarget.value !== this.collection.state.currentPage
                        && +e.currentTarget.value >=  this.collection.state.firstPage
                        && +e.currentTarget.value <=  this.collection.state.totalPages
                    ){
                        this.collection.getPage(+e.currentTarget.value)
                        var params = (+e.currentTarget.value!==1)?("page:"+e.currentTarget.value):"";
					    Backbone.history.navigate('/'+this.collection.state.type+ ((params)?"/list/f/"+params:""));
					    if(typeof ga != "undefined"){ ga('set','page',  '/'+this.collection.state.type+ ((params)?"/list/f/"+params:"")); }
						if(typeof gtag != "undefined"){ gtag('set', { 'page_path': '/'+this.collection.state.type+ ((params)?"/list/f/"+params:""), 'page_location': window.location.origin+'/'+this.collection.state.type+ ((params)?"/list/f/"+params:"") }); }
                    }
                }
            }
        })
	
	
    return new (pagingView)();
});

